export default __webpack_public_path__ + "static/media/background.2d7107c4.jpg";